import { render } from "./FetchError.vue?vue&type=template&id=2903aac6"
import script from "./FetchError.vue?vue&type=script&lang=js"
export * from "./FetchError.vue?vue&type=script&lang=js"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__